module.exports = __webpack_public_path__ + "img/wordmark.5338022d.svg";